import * as types from '../types'

// initial state
let user = {}
if (localStorage.getItem('userInfo')) {
  user = JSON.parse(localStorage.getItem('userInfo'))
}
const state = {
  user: user
}

// mutations
const mutations = {
  // 设置用户信息
  [types.SET_USER] (state, user) {
    state.user = user
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js